export const educationData = [
  {
    institution: "Haldia Institute of Technology",
    location: "Haldia, West Bengal",
    degree: "Master of Computer Applications (MCA)",
    score: "CGPA: 9.02",
    year: "Oct. 2024 -- June 2026",
    desc: "Focusing on Cloud Architecture, SRE & Observability, Distributed Systems, and Advanced Software Engineering. Active in tech community and practical cloud deployments.",
    image: "/images/hit.png",
    current: true
  },
  {
    institution: "Hijli College (Affiliated to Vidyasagar University)",
    location: "Kharagpur, West Bengal",
    degree: "Bachelor of Science (Honours) in Computer Science",
    score: "CGPA: 7.90",
    year: "Sep. 2021 -- Aug. 2024",
    desc: "Studied Core Computer Science, Data Structures & Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    image: "/images/hijli.png",
    current: false
  },
  {
    institution: "Nachipur Adibasi High School (H.S.)",
    location: "Keshiary, West Bengal",
    degree: "Higher Secondary (WBCHSE) - 12th Grade",
    score: "Percentage: 82.40%",
    year: "July 2021",
    desc: "Completed Higher Secondary education with Science stream (Mathematics, Physics, Chemistry, and Biology).",
    image: "/images/school.png",
    current: false
  },
  {
    institution: "Nachipur Adibasi High School (H.S.)",
    location: "Keshiary, West Bengal",
    degree: "Secondary Examination (WBBSE) - 10th Grade",
    score: "Percentage: 78.29%",
    year: "2019",
    desc: "Completed Secondary School education with strong foundation in general sciences and mathematics.",
    image: "/images/school.png",
    current: false
  }
];